import ShippingPage from '../../components/ShippingPage';
import ShippingRestrictionForm from '../components/ShippingRestrictionForm';
import { useShippingRestrictionPage } from '../hooks';

function EditShippingRestrictionPage(): JSX.Element {
  const {
    values,
    handleOnSubmit,
    handleChange,
    setFieldValue,
    errors,
    isUpdating,
    isLoadingError,
    title,
    currentRestrictionId,
    showSkeleton,
    handleRetryDetail,
  } = useShippingRestrictionPage({ mode: 'edit' });

  return (
    <ShippingPage
      title={title}
      handleSave={handleOnSubmit}
      isUpdating={isUpdating}
      isError={isLoadingError}
      isLoading={showSkeleton}
    >
      {showSkeleton && <ShippingRestrictionForm.Skeleton />}

      {!showSkeleton && (
        <ShippingRestrictionForm
          values={values}
          onChange={handleChange}
          onArrayChange={setFieldValue}
          errors={errors}
          currentRestrictionId={currentRestrictionId}
          isErrorDetail={isLoadingError}
          onRetryDetail={handleRetryDetail}
        />
      )}
    </ShippingPage>
  );
}

export default EditShippingRestrictionPage;
